import { useMemo } from "react";
import { useOrdreStore } from "@store/ordreStore";
import { navigateTo } from "context/navigation.service";

export default function DevisEnAttenteWidget() {
  const ordres = useOrdreStore((s) => s.ordres);

  const pending = useMemo(() => {
    return ordres.filter(
      (o) => o.devis_requested && !o.devis_signed && o.status !== "restitue"
    ).slice(0, 8);
  }, [ordres]);

  return (
    <div className="flex flex-col bg-white border rounded-xl p-4 gap-2 shadow-lg">
      <div className="flex flex-row justify-between items-center mb-1">
        <div className="font-semibold text-black">Devis en attente</div>
        {pending.length > 0 && (
          <span className="text-h4 font-medium rounded-full px-2 py-0.5 bg-amber-50 text-amber-600">
            {pending.length}
          </span>
        )}
      </div>
      {pending.length === 0 && (
        <div className="text-h3 text-neutral-400 py-2">Aucun devis en attente de signature</div>
      )}
      <div className="flex flex-col divide-y">
        {pending.map((order) => (
          <div
            key={order.id}
            className="flex flex-row items-center py-2.5 px-1 gap-3 cursor-pointer hover:bg-neutral-50 rounded-lg"
            onClick={() => navigateTo({ route: `/ordre/${order.id}` })}
          >
            <div className="flex flex-col flex-1 min-w-0">
              <div className="text-h2 font-medium text-black">{order.name}</div>
              <div className="text-h3 text-neutral-400">{order.immatriculation}</div>
            </div>
            {order.amount != null && (
              <span className="text-h2 font-medium text-neutral-600 flex-shrink-0">
                {order.amount.toLocaleString("fr-FR")} EUR
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
